var map = {
	"./additional/machineCategories/route": "1db0",
	"./additional/machines/route": "4b51",
	"./additional/messages/route": "5ce0",
	"./additional/operators/route": "d143",
	"./additional/substrates/route": "b153",
	"./baskets/route": "98b8",
	"./dashboard/route": "97fb",
	"./jobs/route": "e870",
	"./notifications/route": "cb97",
	"./settings/digitalSettings/route": "8b84",
	"./settings/printProviders/route": "ada6",
	"./settings/replacements/route": "1422",
	"./statistics/route": "5af7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84b8";